/* @flow */

import { parseResponse } from 'src/shared/app/base/util/ajaxUtils';
import type { Methods } from 'src/shared/app/base/middleware/httpMethodMiddleware';
import type { GetState } from 'src/shared/core/type/reduxTypes';

type Args = {
  url: string,
  next: string,
  params: Object,
  method: $Keys<Methods>,
};
type API = { signal: any, dispatch: Function, getState: GetState };

// https://redux-toolkit.js.org/rtk-query/usage/customizing-queries
export default () =>
  ({ url, next, params, method = 'get' }: Args, api: API) =>
    api.dispatch(async (dispatch: any, _: GetState, methods: Methods) => {
      const methodCb = methods[method];

      try {
        const response = next
          ? await methodCb(next)
          : await methodCb(url, params);

        const parsedResponse = await parseResponse(response);
        return {
          data: parsedResponse,
        };
      } catch (e) {
        return { error: e.json || e.message };
      }
    });
